export default __webpack_public_path__ + "static/media/wrong_beverages@3x.b82555dc.jpg";